import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
interface ImageLightboxProps {
  image: {
    src: string;
    caption: string;
  } | null;
  onClose: () => void;
}

/** Full-screen image preview, rendered above everything (including side panels). */
export function ImageLightbox({
  image,
  onClose
}: ImageLightboxProps) {
  const {
    t
  } = useLanguage();
  useEffect(() => {
    if (!image) return;
    // Capture phase so Escape closes only the lightbox, not the panel underneath.
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        e.stopPropagation();
        onClose();
      }
    };
    window.addEventListener('keydown', onKey, true);
    return () => window.removeEventListener('keydown', onKey, true);
  }, [image, onClose]);
  return createPortal(<AnimatePresence data-id="element-2030" data-mp="1i3osc80mcqif">
      {image && <motion.div key="lightbox" role="dialog" aria-modal="true" aria-label={image.caption} className="fixed inset-0 z-[2000] bg-slate-950/90 flex flex-col items-center justify-center p-4 sm:p-10" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.15
    }} onClick={onClose} data-id="element-2031" data-mp="1tebnaneigdm0">
          <button type="button" onClick={onClose} aria-label={t('Fermer l’aperçu', 'Close preview')} className="absolute top-4 right-4 p-2 rounded-lg text-white/80 hover:text-white hover:bg-white/10" data-id="element-2032" data-mp="2d219mf3ohlnu">
            <XIcon className="w-6 h-6" data-id="element-2033" data-mp="236hbrn5k0cwg" />
          </button>
          <motion.img src={image.src} alt={image.caption} className="max-w-full max-h-[85vh] object-contain rounded-lg shadow-2xl" initial={{
        scale: 0.96
      }} animate={{
        scale: 1
      }} exit={{
        scale: 0.96
      }} transition={{
        duration: 0.18,
        ease: 'easeOut'
      }} onClick={e => e.stopPropagation()} data-id="element-2034" data-mp="281wo2anwy0qr" />
          <p className="mt-4 text-sm text-white/80" data-id="element-2035" data-mp="8lmhtc0i8ukg">{image.caption}</p>
        </motion.div>}
    </AnimatePresence>, document.body);
}